import { useContext } from 'react';
import { NotificationContext } from './NotificationProvider';

export const useNotifications = () => useContext(NotificationContext);
